const MAX_CONCURRENT = 3;
const queue = [];
let active = 0;

function drain() {
	while (active < MAX_CONCURRENT && queue.length > 0) {
		const job = queue.shift();
		active += 1;
		Promise.resolve()
			.then(job.fn)
			.then(job.resolve, job.reject)
			.finally(() => {
				active -= 1;
				drain();
			});
	}
}

export function enqueueProfilePicSync(fn) {
	return new Promise((resolve, reject) => {
		queue.push({ fn, resolve, reject });
		drain();
	});
}

export function isSocketIoMisroutePayload(data) {
	return (
		data &&
		data.code === 1 &&
		typeof data.message === "string" &&
		/session id unknown/i.test(data.message)
	);
}
